/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zombie_Nav_HowInputs */

const en_zombie_nav_how = /** @type {(inputs: Zombie_Nav_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const zh_zombie_nav_how = /** @type {(inputs: Zombie_Nav_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用方法`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Zombie_Nav_HowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const zombie_nav_how = /** @type {((inputs?: Zombie_Nav_HowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zombie_Nav_HowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zombie_nav_how(inputs)
	return zh_zombie_nav_how(inputs)
});
export { zombie_nav_how as "zombie.nav.how" }